export default "__VITE_ASSET__Drz1PkFh__"